const jobFilters = ({ el }) => {

   /**
    * Triggers the filter optioned to open and close
    */
   const triggerSection = el.querySelector('[data-job-filter-triggers]');
   const filterGroups = [...triggerSection.querySelectorAll('[data-job-filter-group]')];
   const activeFilterGroupClass = 'job-filter__group--active';

   filterGroups.forEach(group => {
      const triggerButton = group.querySelector('button');
      triggerButton.addEventListener('click', () => {
         group.classList.toggle(activeFilterGroupClass);
      });
   });

   const updateSearchResults = () => {
      /**
       * Establish search parameters and get the values from the current url
       */
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const jobTypeQuery = urlParams.get('job_type');
      const positionQuery = urlParams.get('position');
      const salaryTypeQuery = urlParams.get('salary_type');
      const salaryValueQuery = urlParams.get('salary_band_value');
      const dayRateValueQuery = urlParams.get('day_rates_value');
      
      /**
       * Get all items on the page &
       * Set the hidden class name for future reference
       * Set 'returnNothing' to true as a starting point
       */
      const allItems = [...el.querySelectorAll('[data-js-job-item]')];
      const hiddenClass = 'job-filter-item--hidden';
      let returnNothing = true;

      /**
       * Loop through all items on the page
       */
      allItems.forEach(item => {
         /**
          * Firstly, set all items to be hidden,
          * Set the 'showItem' to be false so it defaults to not show
          * Then set a variable for each parameter which defaults as false (works as a reset)
          */
         item.classList.add(hiddenClass);
         let showItem = false;
         let positionMatch = false;
         let jobTypeMatch = false;
         let salaryTypeMatch = false;
         let salaryValueMatch = false;
         let dayRateValueMatch = false;

         /**
          * Going through each parameter, checks if it is set.
          * If it is then it checks to see if the current item is a match
          * If it is amatch then sets the coresponding match variable to true
          * If the parameter isn't set then still sets as true as default it will still show
          */
         if (positionQuery) {
            const positionQueryArray = positionQuery.split(';');
            positionQueryArray.forEach(arrayItem => {
               if (positionMatch === false) {
                  if (item.dataset.jobFilterPosition.includes(arrayItem)) {
                     positionMatch = true;
                  }
               }
            });
         } else {
            positionMatch = true;
         }

         if (jobTypeQuery) {
            const jobTypeQueryArray = jobTypeQuery.split(';');
            jobTypeQueryArray.forEach(arrayItem => {
               if (jobTypeMatch === false) {
                  if (item.dataset.jobFilterType.includes(arrayItem)) {
                     jobTypeMatch = true;
                  }
               }
            });
         } else {
            jobTypeMatch = true;
         }

         if (salaryTypeQuery) {
            const salaryTypeQueryArray = salaryTypeQuery.split(';');
            salaryTypeQueryArray.forEach(arrayItem => {
               if (salaryTypeMatch === false) {
                  if (item.dataset.jobFilterSalaryType.includes(arrayItem)) {
                     salaryTypeMatch = true;
                  }
               }
            });
         } else {
            salaryTypeMatch = true;
         }

         if (salaryValueQuery) {
            const salaryValueQueryArray = salaryValueQuery.split(';');
            salaryValueQueryArray.forEach(arrayItem => {
               if (salaryValueMatch === false) {
                  if (item.dataset.jobFilterSalaryValue.includes(arrayItem)) {
                     salaryValueMatch = true;
                  }
               }
            });
         } else {
            salaryValueMatch = true;
         }

         if (dayRateValueQuery) {
            const dayRateValueQueryArray = dayRateValueQuery.split(';');
            dayRateValueQueryArray.forEach(arrayItem => {
               if (dayRateValueMatch === false) {
                  if (item.dataset.jobFilterDayRates.includes(arrayItem)) {
                     dayRateValueMatch = true;
                  }
               }
            });
         } else {
            dayRateValueMatch = true;
         }

         /**
          * Checks if each match variable is true and if so then sets 'showItem' to true
          */
         if (positionMatch && jobTypeMatch && salaryTypeMatch && salaryValueMatch && dayRateValueMatch) {
            showItem = true;
         }

         /**
          * If 'showItem' is true then it removes the hidden class that was added at the start
          * Also checks if 'returnNothing' is still true.
          * If so, then it sets it to false as we now know there is at least one item to show
          */
         if (showItem) {
            item.classList.remove(hiddenClass);
            if (returnNothing) {
               returnNothing = false;
            }
         }
      });

      /**
       * If there are no results then we want to remove the 'hidden' class from the 'No Results' section
       */
      if (returnNothing) {
         const noResultsSection = el.querySelector('[data-jobs-no-results]');
         const jobListingSection = el.querySelector('[data-js-job-listing-container]');
         noResultsSection.classList.remove('archive-jobs__no-results--hidden');
         jobListingSection.classList.remove('border-l');
      }
   }

   /**
    * Checks if there is the parameter of 'filter_jobs' to determine if the results need to be filtered
    */
   if (window.location.href.includes('?filter_jobs')) {
      updateSearchResults();
   }

   const jobFilterButtons = [...el.querySelectorAll('[data-job-filter-value]')];
   jobFilterButtons.forEach(filterButton => {
      /**
       * Event listener for each filter option on click
       */
      filterButton.addEventListener('click', (event) => {
         event.preventDefault();
         /**
          * Get the value and the key of the item that has been clicked and set the start of the url parameter
          */
         const value = filterButton.dataset.jobFilterValue;
         const key = filterButton.dataset.jobFilterKey;
         let urlParameters = '/jobs';

         /**
          * Checks if there are already filters for the page
          * If true, continue to the function
          * If false, Simply add the new filter options to the end of the URL
          */
         if (window.location.href.includes('?filter_jobs')) {
            /**
             * Retrieve all paramater data from the URL
             */
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const jobTypeQuery = urlParams.get('job_type');
            const positionQuery = urlParams.get('position');
            const salaryTypeQuery = urlParams.get('salary_type');
            const salaryValueQuery = urlParams.get('salary_band_value');
            const dayRateValueQuery = urlParams.get('day_rates_value');
   
            /**
             * Create an empty array
             * Then loop through all of the active params (from the url) and build up the array of data to search through
             */
            const filtersArray = [];
            if (jobTypeQuery) {
               filtersArray.push(
                  {
                     key: 'job_type',
                     value: jobTypeQuery,
                  }
               );
            }
            if (positionQuery) {
               filtersArray.push(
                  {
                     key: 'position',
                     value: positionQuery,
                  }
               );
            }
            if (salaryTypeQuery) {
               filtersArray.push(
                  {
                     key: 'salary_type',
                     value: salaryTypeQuery,
                  }
               );
            }
            if (salaryValueQuery) {
               filtersArray.push(
                  {
                     key: 'salary_band_value',
                     value: salaryValueQuery,
                  }
               );
            }
            if (dayRateValueQuery) {
               filtersArray.push(
                  {
                     key: 'day_rates_value',
                     value: dayRateValueQuery,
                  }
               );
            }
   
            /**
             * Now we have all the data of the current page filters.
             * What we need to do next is to add or remove the item we have just clicked and generate the new URL
             * Create variable called 'hasBeenAdded' and set as false. If the item clicked doesn't exist in the URL structure then this will add it to the array.
             */
            let hasBeenAdded = false;
            filtersArray.forEach((filterGroup, index) => {
               /**
                * We are going to loop through the array of data (from URL) until we get to the key of the item we have clicked
                */
               if (key === filterGroup.key) {
                  const filterGroupValue = filterGroup.value;
                  /**
                   * Checks if the value from the URL data includes the value we have just clicked
                   * If true, then we know the page is being filtered by that value and we want to REMOVE it
                   * If false, We know we are adding the new value to the end of the URL for the next refresh
                   */
                  if (filterGroupValue.includes(value)) {
                     /**
                      * Now we know that the value exists, we need to establish if the key being filtered is just the one value or multiple
                      * If true, we need to either remove the ';' either after it (if it is the first item) or after it (any other placement)
                      * If false, then we remove the entire search parameter from the main array
                      */
                     if (filterGroupValue.includes(';')) {
                        const notFirstValue = `;${value}`;
                        const firstValue = `${value};`;
                        if (filterGroupValue.includes(notFirstValue)) {
                           filtersArray[index]['value'] = filtersArray[index]['value'].replace(notFirstValue, '');
                        } else {
                           filtersArray[index]['value'] = filtersArray[index]['value'].replace(firstValue, '');
                        }
                     } else {
                        filtersArray.splice(index, 1);
                     }
                  } else {
                     filtersArray[index]['value'] = `${filtersArray[index]['value']};${value}`;
                  }
                  /**
                   * Set hasBeenAdded to true as it has been covered by what already exists.
                   */
                  hasBeenAdded = true;
               }
            });

            /**
             * If 'hasBeenAdded' is still false that means that it needs to be added
             * Simply pushes a new item to 'filtersArray' for the reload to cater for
             */
            if (!hasBeenAdded) {
               filtersArray.push(
                  {
                     key: key,
                     value: value
                  }
               );
            }
   
            if (filtersArray.length > 0) {
               urlParameters = `${urlParameters}?filter_jobs`;
            }
            filtersArray.forEach(filter => {
               urlParameters = `${urlParameters}&${filter['key']}=${filter['value']}`;
            });
         } else {
            urlParameters = `${urlParameters}?filter_jobs&${key}=${value}`;
         }
         window.location.href = urlParameters;
      });
   });
}

export default jobFilters;